import React, { useState } from "react";

import LogoUlagos from "../../assets/img/logo_ulagos.png";

const SignInScreen = () => {
  const [showError, setShowError] = useState(false);

  const handleSignIn = (event) => {
    event.preventDefault();
    setShowError(true);
  };

  return (
    <div className="p-4 p-lg-5">
      <div className="text-center mb-3">
        <img src={LogoUlagos} alt="Universidad de Los Lagos" className="signin-logo mb-2" />
        <h1 className="h4 text-gray-900 mb-0">Sistema de Encuestas Institucionales</h1>
      </div>
      <form onSubmit={handleSignIn} className="user">
        <div className="form-group mb-2">
          <label htmlFor="exampleInputEmail" className="font-weight-bold small mb-1">
            Correo institucional
          </label>
          <input
            type="email"
            className="form-control form-control-user"
            id="exampleInputEmail"
            aria-describedby="emailHelp"
            placeholder="nombre.apellido@ulagos.cl"
          />
        </div>
        <div className="form-group mb-2">
          <label htmlFor="exampleInputPassword" className="font-weight-bold small mb-1">
            Contraseña
          </label>
          <input
            type="password"
            className="form-control form-control-user"
            id="exampleInputPassword"
            placeholder="Ingrese su contraseña"
          />
        </div>
        <div className="form-group mb-2">
          <div className="small custom-control custom-checkbox">
            <input type="checkbox" className="custom-control-input" id="customCheck" />
            <label className="custom-control-label font-weight-bold" htmlFor="customCheck">
              Recordarme
            </label>
          </div>
        </div>
        {showError && (
          <div className="alert alert-danger py-2 small mb-3" role="alert">
            Usted no tiene acceso a la plataforma de gestión.
          </div>
        )}
        <button type="submit" className="btn btn-primary btn-user btn-block font-weight-bold">
          Iniciar sesión
        </button>
      </form>
      <hr className="my-3" />
      <div className="text-center">
        <div className="small font-weight-bold">
          Si olvidó su contraseña, <a href="forgot-password.html">contactarse con soporte.</a>
        </div>
      </div>
    </div>
  );
};

export default SignInScreen;